import gql from 'graphql-tag';

export default gql`
    mutation PauseStages($input: PauseStagesInput) {
        pauseStages(input: $input) {
            errors
        }
    }
`;
